import {getStepsAtStepNumber} from './step.js';
import {isNumber} from 'utils/IsNumber.js';
import {changeTrackLength} from './length.js';

export function executeParameterCommand(sequencerEngine, command) {
    let tokens = command.split("=");
    if (tokens.length != 2) {
        return false;
    }

    let parameter = tokens[0];
    let value = tokens[1];
    if (!isNumber(value)) {
        return false;
    }
    value = parseFloat(value);

    if (parameter === 'length') {
        changeTrackLength(sequencerEngine, value);
        return true;
    }

    let steps = getStepsAtStepNumber(sequencerEngine);
    for (let i in steps) {
        let stepData = steps[i];

        if (!(parameter in stepData)) {
            return false;
        }

        stepData[parameter] = value;
    }

    sequencerEngine.getSelectedTrack().updateSteps();

    return true;
}
